import * as _ from 'lodash';
import { Button as BSButton, Modal } from 'react-bootstrap';
import { window } from '../../../globals';

type ModalServiceConnectProps = {
  show: boolean;
  serviceDisplayName: string;
  service: string;
  // eslint-disable-next-line max-len
  hardRedirectToAuthorizeURL: ({ service, nextUrl, serviceConnect }: { service: string, nextUrl: string; serviceConnect: boolean }) => void;
};

const ModalServiceConnect = ({
  show,
  serviceDisplayName,
  hardRedirectToAuthorizeURL,
  service,
}: ModalServiceConnectProps) => (
  <Modal show={show} onHide={_.noop}>
    <Modal.Header>
      <Modal.Title>Link {serviceDisplayName} account to user?</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <div>
        <p>This will allow you to log in to FOSSA using this {serviceDisplayName} profile</p>
      </div>
    </Modal.Body>
    <Modal.Footer>
      <BSButton
        onClick={() => {
          hardRedirectToAuthorizeURL({
            service,
            nextUrl: window.location.href,
          });
        }}>
        No (Proceed without linking)
      </BSButton>
      <BSButton
        onClick={() => {
          hardRedirectToAuthorizeURL({
            service,
            nextUrl: window.location.href,
            serviceConnect: true,
          });
        }}
        bsStyle="success">
        Yes (Link account)
      </BSButton>
    </Modal.Footer>
  </Modal>
)

export default ModalServiceConnect;
